// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zvbS","icon":"styles_icon__xBbOa"};